export default __webpack_public_path__ + "static/media/yahbunyi.49e59f6f.wav";